import React, {useEffect, useState} from 'react'
import { Form } from 'react-bootstrap'
import { changePassword, uData, updateUser } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {DeleteForever } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import Cookie from 'react-cookies';
const ChangePassword = () => {
	const navigate = useNavigate()
	const [data, setData ] = useState();

    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if(data.password === data.confirmPassword){
            const res = await changePassword(data);
            if(res.success){
                Swal.fire({
                    title: 'Successful',
                    icon:"success",
                    text: res.message,
                    closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
                })
                e.target.reset();
            }else{
                Swal.fire({
                    title: 'Failed',
                    icon:"error",
                    text: res.message,
                    closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
                })
            }
        }else{
            Swal.fire({
				title: 'Warning',
				icon:"warning",
				text: 'Password does not match with confirm password.',
				closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
			})
        }
        
    }

	useEffect(() => {
		document.title = 'Change Password | Taste Place Investment'

	}, [])

  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">Update Password </b></h4> 
      <div className="card">
		<div className="card-body">
			<form action="" id="newUser"
			onSubmit={handleSubmit}
			>
				<div className="row justify-content-center">
					<div className="col-md-6 border-right">
						
						<div className="form-group">
							<label for="" className="control-label">Enter Existing Password</label>
							<input
							onChange={handleChange}
							type="password" name="old_pass" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Enter New Password </label>
							<input 
							onChange={handleChange}
							type="password" className="form-control form-control-sm" name="password"  />
							<small id="#msg"></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Confirm New Password</label>
							<input 
							onChange={handleChange}
							type="password" name="confirmPassword" className="form-control form-control-sm"  />
						</div>
					</div>
				</div>
				<hr />
				<div className="col-lg-12 text-right justify-content-center d-flex">
					 <button className="btn btn-danger btn-lg" type="button" 
					 onClick={()=> {
						navigate('/dashboard');
					 }}
					//  style={{ width: '120px' }}
					 >Cancel</button>
					 <button
					 
					 className="btn btn-color btn-lg ms-2"
					//   style={{ width: '120px' }}
					 >Continue</button> 
				</div>
			</form>
		</div>
	</div>
    </div>
  )
}

export default ChangePassword